import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=9085424c&lang=scss"

const __exports__ = script;

export default __exports__